import { format } from "date-fns";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AddEcgIcon, AddVitalIcon } from "../shared/svgIcon";
import { cn } from "../shared/utils";
import { getConsumerDetail, getVitals } from "../lib/api";
import { useStore } from "../store";

const MyHealth = () => {
  let navigate = useNavigate();
  const vitalSession = useStore((state) => state.currentVitals);
  const ecgSession = useStore((state) => state.currentEcg);
  const setSelectedVitals = useStore((state) => state.setSelectedVitals);
  const setSelectedEcg = useStore((state) => state.setSelectedEcg);

  const goToVitals = (index) => {
    setSelectedVitals(vitalSession);
    navigate("/vitalSummary");
  };
  const goToEcg = (index) => {
    setSelectedEcg(ecgSession);
    navigate("/ecgView");
  };

  const goToHome = (index) => {
    navigate("/dashboard");
  };

  const [vitalData, setVitalData] = useState(null);
  const [vitalDate, setVitalDate] = useState(null);
  const [ecgData, setEcgData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const tabs = [
    {
      key: "vital",
      title: "Vital",
      style: {
        background:
          "linear-gradient(114deg, rgba(228.28, 249.69, 227.84, 0.50) 0%, rgba(211.42, 253.94, 210.56, 0.50) 100%)",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.06)",
        border: "1px #99E099 solid",
      },
      Icon: <AddVitalIcon height={"36px"} width={"30px"}></AddVitalIcon>,
      Link:'/vitalHistory',
      color: "#32B569",
      IconStyle: {
        right: "20px",
        bottom: "15px",
      },
    },
    {
      key: "ecg",
      title: "ECG",
      style: {
        background: "linear-gradient(123deg, #FFEEEE 0%, #FFD0D0 100%)",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.06)",
        border: "1px #EDA2A2 solid",
      },
      Icon: <AddEcgIcon height={"36px"} width={"30px"}></AddEcgIcon>,
      color: "#EDA2A2 ",
      Link:'/documentHistory?type=ecg',
      IconStyle: {
        color:'#E93A3A',
        right: "20px",
        bottom: "15px",
      },
    },
    {
      key: "reports",
      title: "My Reports",
      style: {
        background: "linear-gradient(111deg, #F5F8FF 0%, #D3DFFE 100%)",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.06)",
        border: "1px #9EB9FF solid",
      },
      Icon: <AddEcgIcon height={"36px"} width={"30px"}></AddEcgIcon>,
      color: "#9EB9FF ",
      Link:'/documentHistory',
      IconStyle: {
        color:'#1d5cff',
        right: "20px",
        bottom: "15px",
      },
    },
  ];
  const getVitalInfo = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }
      // const vitalSession = sessionStorage.getItem('currentVitals') ? JSON.parse(sessionStorage.getItem('currentVitals')):null;
      if (vitalSession) {
        const inputDate = new Date(vitalSession?.date);
        const formattedDate = format(inputDate, "dd/MM/yyyy");
        setVitalData(vitalSession?.data);
        setVitalDate(formattedDate);
        setLoading(false);
        return;
      }
      setLoading(true);
      const res = await getVitals({ patientId });
      const result = res?.data?.result;
      if (result?.[result?.length - 1])
        sessionStorage.setItem(
          "currentVitals",
          JSON.stringify(result[result?.length - 1])
        );
      const vitalDetails = result?.[result?.length - 1]?.data;
      if (vitalDetails) {
        setVitalData(vitalDetails);
      }
      const date = result?.[result?.length - 1]?.date;
      if (date) {
        const inputDate = new Date(date);
        const formattedDate = format(inputDate, "dd/MM/yyyy");
        setVitalDate(formattedDate);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getEcgInfo = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }
      // const ecgSession = sessionStorage.getItem("currentEcg")
      //   ? JSON.parse(sessionStorage.getItem("currentEcg"))
      //   : null;
      // console.log(ecgSession, "ecgSession");
      if (ecgSession) {
        setEcgData(ecgSession);
        setLoading(false);
        return;
      }
      setLoading(true);
      const res = await getConsumerDetail(patientId);
      const result = res?.data?.result?.ecg;
      const ecgDetails = result?.[result?.length - 1];
      if (result?.[result?.length - 1])
        sessionStorage.setItem("currentEcg", JSON.stringify(ecgDetails));
      setEcgData(ecgDetails);
      setLoading(false);
      // console.log(ecgDetails, "ecg");
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    // getVitalInfo();
    // getEcgInfo();
  }, []);

  return (
    <div className="bg-gray-50 sh-screen">
      <div className="flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
        <div>
          <Link className="flex" to="/Dashboard">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">My Health</h4>
            </div>
          </Link>
        </div>
      </div>
      <div className=" flex-1 overflow-scroll hideScroll   flex flex-col md:flex-row pt-16 p-4 gap-4">
        {/* {!isLoading && !vitalData && (
          <div
            className="w-full  rounded-xl border-2 bg-gradient-to-br bg-green-100 border-green-300 text-center flex flex-col   py-4 cursor-pointer  font-semibold text-lg"
            onClick={goToVitals}
          >
            <div className="flex justify-between items-center  w-full px-4">
              <p className="flex font-bold text-xl ">Vitals</p>
              {vitalDate && (
                <div className="px-4 py-2 border rounded-full text-sm border-green-300">
                  {vitalDate}
                </div>
              )}
            </div>
            <div className="flex justify-between  w-full px-4 pt-4 pb-2">
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">SpO2</p>
                <div className="flex font-bold text-base items-start">
                  {vitalData?.spo2?.value ?? "-"}
                </div>
              </div>
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">Pulse</p>
                <div className="flex font-bold text-base items-start">
                  {vitalData?.hr?.value ?? "-"}
                </div>
              </div>
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">
                  Respiratory
                </p>
                <div className="flex font-bold text-base items-start">
                  {vitalData?.rr?.value ?? "-"}
                </div>
              </div>
            </div>
            <div className="flex justify-end items-center  w-full px-4">
              <p className="flex font-semibold text-base bg-green-500 text-white px-2 py-1 mt-1 rounded-full">
                View More
              </p>
            </div>
          </div>
        )} */}
        {/* {!isLoading && ecgData && (
          <div
            className="w-full  rounded-xl border-2 bg-gradient-to-r bg-violet-100 border-indigo-300 text-center flex flex-col   py-4 cursor-pointer  font-semibold text-lg"
            onClick={goToEcg}
          >
            <div className="flex justify-between items-center  w-full px-4">
              <p className="flex font-bold text-xl ">ECG</p>
              {ecgData?.created_date && (
                <div className="px-4 py-2 border rounded-full text-sm border-indigo-300">
                  {format(new Date(ecgData?.created_date), "dd/MM/yyyy")}
                </div>
              )}
            </div>
            <div className="flex justify-between  w-full px-4 pt-4 pb-2">
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">
                  Scale mm/s
                </p>
                <div className="flex font-bold text-base items-start">
                  {ecgData?.inference?.extras?.scale_mm_per_s | "-"}
                </div>
              </div>
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">
                  Scale mm/mV
                </p>
                <div className="flex font-bold text-base items-start">
                  {ecgData?.inference?.extras?.scale_mm_per_mV || "-"}
                </div>
              </div>
              <div className="flex flex-col">
                <p className="flex font-bold text-base items-start">MF</p>
                <div className="flex font-bold text-base items-start">
                  {ecgData?.inference?.extras?.mains_frequency || "-"}
                </div>
              </div>
            </div>
            <div className="flex justify-end items-center  w-full px-4">
              <p className="flex font-semibold text-base bg-violet-500 text-white px-2 py-1 mt-1 rounded-full">
                View More
              </p>
            </div>
          </div>
        )} */}
        {isLoading && (
          <div className="animate-pulse flex flex-col h-36 cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300 ">
            <div className="m-2 w-full  bg-slate-200 h-4"></div>
            <div className="m-2 w-full  bg-slate-200 h-4"></div>
            <div className="m-2  w-full  bg-slate-200 h-2"></div>
          </div>
        )}
        {!isLoading && (
          <div className=" flex flex-row justify-center gap-3  items-center flex-1 flex-wrap p-3 mt-10">
            {/* <div>
              <AddVitalIcon width={"100px"} height={"200px"} />
            </div>
            <h1 className="text-xl font-bold">No Data</h1>
            <p className="text-gray-400 text-base font-semibold m-4">
              Please Add Your Health Information
            </p>
            <button
              className={cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                "bg-secondary text-primary-foreground shadow hover:opacity-40",
                "h-10 rounded-md px-8"
              )}
              onClick={goToHome}
            >
              Go Home
            </button> */}
            {tabs.map((e,index) => (
              <Link key={index}  to={e.Link}
                className="w-[48%] sm:w-[30%] md:w-[15%] h-[112px] min-w-[170px] relative flex flex-col justify-between p-4 rounded-2xl mb-2"
                style={e.style}
              >
                <div className="flex flex-col text-xl  font-bold justify-center items-center gap-3">
                  <div className=" leading-none" style={e.IconStyle}>
                    {e.Icon}
                  </div>
                  <p className="text-xl leading-none text-primary">{e.title}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyHealth;
